import type { ResultOf } from "@graphql-typed-document-node/core";
import { graphql } from "../gql";

export const query = graphql(`
    query ImpactTrackerReportQuery($id: ID!, $pwd: String!) {
        impactTrackerReport(id: $id, pwd: $pwd) {
            id
            version
            data
            createdDatetime
            logoSrc
            learningPath {
                id
                name
                pathname
            }
        }
    }
`);

export type ILearningPath = NonNullable<ResultOf<typeof query>["impactTrackerReport"]>["learningPath"];
